import React, { Component } from "react";
import PropTypes from "prop-types";
import withAuthenticationContext from "../../hocs/withAuthenticationContext";
import withGlobalContext from "../../hocs/withGlobalContext";
import { withToastManager } from "react-toast-notifications";
import axios from "axios";
import { withTranslation } from 'react-i18next';
import SidebarRightMobile from "../Sidebars/SidebarRightMobile";
import QuestiaUIUtils from "../../utils/QuestiaUIUtils";

class Contact extends Component {
    static propTypes = {
        globalContext: PropTypes.object.isRequired,
        authenticationContext: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            userData: undefined,
            disableActions: false,
            isUserLogged: false,

            firstName: undefined,
            firstNameValid: undefined,

            lastName: undefined,
            lastNameValid: undefined,

            email: "",
            emailValid: undefined,

            subject: undefined,
            subjectValid: undefined,

            content: undefined,
            contentValid: undefined,
        };

        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleSubjectChange = this.handleSubjectChange.bind(this);
        this.handleContentChange = this.handleContentChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount = () => {
        var {userInfo} = this.props.globalContext;
        var {userId} = this.props.globalContext.globals;

        if (typeof userId === "undefined") {

        } else {
            this.setState({
                firstName: userInfo.user.user_surname, firstNameValid: true,
                lastName: userInfo.user.user_lastname, lastNameValid: true,
                email: userInfo.user.user_email, emailValid: true,
                userData: userInfo, isUserLogged: true
            });
        }
    };


    handleFirstNameChange(event) {
        if (!this.state.isUserLogged) {
            let firstName = event.target.value;
            var isName = this.props.authenticationContext.functions.isStringAName(firstName);
            if (firstName === "") {
                this.setState({firstName: firstName, firstNameValid: false});
                QuestiaUIUtils.computeAndAddHeightForErrorMessage("inputFirstName", "spanFirstName", false);
            } else {

                this.setState({firstName: firstName, firstNameValid: isName});
                QuestiaUIUtils.computeAndAddHeightForErrorMessage("inputFirstName", "spanFirstName", isName);
            }
        }
    }

    handleLastNameChange(event) {
        if (!this.state.isUserLogged) {
            let lastName = event.target.value;
            var isName = this.props.authenticationContext.functions.isStringAName(lastName);
            if (lastName === "") {
                this.setState({
                    lastName: lastName,
                    lastNameValid: false
                });
                QuestiaUIUtils.computeAndAddHeightForErrorMessage("inputLastName", "spanLastName", false);
            } else {
                this.setState({
                    lastName: lastName,
                    lastNameValid: isName
                });
                QuestiaUIUtils.computeAndAddHeightForErrorMessage("inputLastName", "spanLastName", isName);
            }
        }
    }

    handleEmailChange(event) {
        if (!this.state.isUserLogged) {
            const {functions} = this.props.authenticationContext;
            let email = event.target.value;
            if(email.includes(" ")) {
                return;
            }
            let emailValid = functions.doesEmailRespectPattern(email);

            if (email === "") {
                this.setState({
                    email: email,
                    emailValid: false
                });
                QuestiaUIUtils.computeAndAddHeightForErrorMessage("inputEmail", "spanEmail", false);
            } else {
                this.setState({
                    email: email,
                    emailValid: emailValid
                });
                QuestiaUIUtils.computeAndAddHeightForErrorMessage("inputEmail", "spanEmail", emailValid);
            }
        }
    }

    handleSubjectChange(event) {
        let subject = event.target.value;
        if (subject === "") {
            this.setState({
                subject: subject,
                subjectValid: false
            });
            QuestiaUIUtils.computeAndAddHeightForErrorMessage("inputSubjectChange", "spanSubjectChange", false);
        } else {
            this.setState({
                subject: subject,
                subjectValid: true
            });
            QuestiaUIUtils.computeAndAddHeightForErrorMessage("inputSubjectChange", "spanSubjectChange", true);
        }
    }
    handleContentChange(event) {
        let content = event.target.value;
        if (content === "") {
            this.setState({
                content: content,
                contentValid: false
            });
            QuestiaUIUtils.computeAndAddHeightForErrorMessage("inputContentChange", "spanContentChange", false);
            QuestiaUIUtils.addBottomForErrorMessage("spanContentChange", false);
        } else {
            this.setState({
                content: content,
                contentValid: true
            });
            QuestiaUIUtils.computeAndAddHeightForErrorMessage("inputContentChange", "spanContentChange", true);
            QuestiaUIUtils.addBottomForErrorMessage( "spanContentChange", true);
        }
    }

    contactUs = (payload, okCallback, koCallback) => {
        axios.post('contactUs/', payload)
            .then(response =>
                okCallback && okCallback(response)
            )
            .catch(response =>
                koCallback && koCallback(response)
            );
    };

    areFieldsValid = () => {
        return (
            this.state.firstNameValid &&
            this.state.lastNameValid &&
            this.state.emailValid &&
            this.state.subjectValid &&
            this.state.contentValid &&
            typeof this.state.firstName !== "undefined" &&
            typeof this.state.lastName !== "undefined" &&
            typeof this.state.email !== "undefined" &&
            typeof this.state.subject !== "undefined" &&
            typeof this.state.content !== "undefined"
        );
    };


    setDefaultData = () => {
        if (this.state.isUserLogged) {
            this.setState({
                disableActions: false,

                subject: "",
                subjectValid: undefined,

                content: "",
                contentValid: undefined,
            });
        } else {
            this.setState({
                userData: undefined,
                disableActions: false,

                firstName: "",
                firstNameValid: undefined,

                lastName: "",
                lastNameValid: undefined,

                email: "",
                emailValid: undefined,

                subject: "",
                subjectValid: undefined,

                content: "",
                contentValid: undefined,
            });
        }
    }

    handleSubmit(event) {

        if (!this.areFieldsValid()) {
            event.preventDefault();
            return;
        }
        this.setState({ disableActions: true },
            () => {

                let payload ={
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    email: this.state.email,
                    subject: this.state.subject,
                    content: this.state.content
                };
                this.contactUs(payload,
                    (success) => {
                        this.props.toastManager.add(this.props.t('contact.content.success',"Your message has been successfully sent."), {
                            appearance: 'success',
                            autoDismiss: window.questiaSpecificWebsiteConfig.NOTIFICATIONS_AUTO_DISMISS,
                            autoDismissTimeout: window.questiaSpecificWebsiteConfig.NOTIFICATIONS_AUTO_DISMISS_TIMEOUT
                        });

                        /* Preset values */
                        this.setDefaultData();
                    },

                    (error) => {
                        if (error.response.data.code === 4) {
                            this.props.toastManager.add(this.props.t('contact.content.error',"An error has occurred. Please write us at"), {
                                appearance: 'warning',
                                autoDismiss: window.questiaSpecificWebsiteConfig.NOTIFICATIONS_AUTO_DISMISS,
                                autoDismissTimeout: window.questiaSpecificWebsiteConfig.NOTIFICATIONS_AUTO_DISMISS_TIMEOUT
                            });
                        } else {
                            this.props.toastManager.add(this.props.t('contact.content.error',"An error has occurred. Please write us at") + window.questiaSpecificWebsiteConfig.CONTACT_EMAIL, {
                                appearance: 'error',
                                autoDismiss: window.questiaSpecificWebsiteConfig.NOTIFICATIONS_AUTO_DISMISS,
                                autoDismissTimeout: window.questiaSpecificWebsiteConfig.NOTIFICATIONS_AUTO_DISMISS_TIMEOUT
                            });
                        }
                        this.setState({
                            disableActions: false
                        });
                    }
                );
            });
        event.preventDefault();
    }


    render() {
        const submitDisabled = !this.areFieldsValid();
        return (
            <section className="main-col">
                <div className="main-col__contact">
                    <div className="main-col__content">
                        <h1 className="main-col__title pv-xs">
                            {this.props.t('contact.content.title',"Send us a message")}
                        </h1>
                        <div className="form">
                            <form onSubmit={this.handleSubmit}>
                                <div className="form-group">
                                    {this.props.t('contact.firstName.content',"First name*")}
                                    <input
                                        className={
                                            typeof this.state.firstNameValid !== "undefined" &&
                                            !this.state.firstNameValid
                                                ? "password-input-js error"
                                                : "password-input-js"
                                        }
                                        id="inputFirstName"
                                        type="text"
                                        placeholder={this.props.t('contact.firstName.placeholder',"E.g. John")}
                                        value={this.state.firstName}
                                        onChange={this.handleFirstNameChange}
                                        disabled={this.state.disableActions || this.state.isUserLogged}
                                    />
                                    <span
                                        className={
                                            typeof this.state.firstNameValid !== "undefined" &&
                                            !this.state.firstNameValid
                                                ? "login-error login-error--password active"
                                                : "login-error login-error--password"
                                        }
                                        id="spanFirstName"
                                    >
                                {this.props.t('contact.firstName.error',"First name incorrect")}
                            </span>
                                </div>
                                <div className="form-group">
                                    {this.props.t('contact.lastName.content',"Surname*")}
                                    <input
                                        className={
                                            typeof this.state.lastNameValid !== "undefined" &&
                                            !this.state.lastNameValid
                                                ? "password-input-js error"
                                                : "password-input-js"
                                        }
                                        id="inputLastName"
                                        type="text"
                                        placeholder={this.props.t('contact.lastName.placeholder',"E.g. Doe")}
                                        value={this.state.lastName}
                                        onChange={this.handleLastNameChange}
                                        disabled={this.state.disableActions || this.state.isUserLogged}
                                    />
                                    <span
                                        className={
                                            typeof this.state.lastNameValid !== "undefined" &&
                                            !this.state.lastNameValid
                                                ? "login-error login-error--password active"
                                                : "login-error login-error--password"
                                        }
                                        id="spanLastName"
                                    >
                                {this.props.t('contact.lastName.error',"Last name incorrect")}
                            </span>
                                </div>
                                <div className="form-group">
                                    {this.props.t('contact.email.content',"E-mail*")}
                                    <input
                                        className={
                                            typeof this.state.emailValid !== "undefined" &&
                                            !this.state.emailValid
                                                ? "password-input-js error"
                                                : "password-input-js"
                                        }
                                        id = "inputEmail"
                                        type="text"
                                        placeholder={this.props.t('contact.email.placeholder',"E.g. myemail@my.domain")}
                                        value={this.state.email}
                                        onChange={this.handleEmailChange}
                                        disabled={this.state.disableActions || this.state.isUserLogged}
                                    />
                                    <span
                                        className={
                                            typeof this.state.emailValid !== "undefined" &&
                                            !this.state.emailValid
                                                ? "login-error login-error--password active"
                                                : "login-error login-error--password"
                                        }
                                        id = "spanEmail"
                                    >
                                {this.props.t('contact.email.error',"E-mail invalid")}
                            </span>
                                </div>
                                <div className="form-group">
                                    {this.props.t('contact.subject.content',"Subject*")}
                                    <input
                                        className={
                                            typeof this.state.subjectValid !== "undefined" &&
                                            !this.state.subjectValid
                                                ? "password-input-js error"
                                                : "password-input-js"
                                        }
                                        type="text"
                                        id="inputSubjectChange"
                                        placeholder={this.props.t('contact.subject.placeholder',"Insert your subject here")}
                                        value={this.state.subject}
                                        onChange={this.handleSubjectChange}
                                        disabled={this.state.disableActions}
                                    />
                                    <span
                                        className={
                                            typeof this.state.subjectValid !== "undefined" &&
                                            !this.state.subjectValid
                                                ? "login-error login-error--password active"
                                                : "login-error login-error--password"
                                        }
                                        id="spanSubjectChange"
                                    >
                                {this.props.t('contact.subject.error',"This is a required field")}
                            </span>
                                </div>
                                <div className="form-group">
                                    {this.props.t('contact.body.content',"Content*")}
                                    <textarea
                                        className={
                                            typeof this.state.contentValid !== "undefined" &&
                                            !this.state.contentValid
                                                ? "error"
                                                : ""
                                        }
                                        id="inputContentChange"
                                        placeholder={this.props.t('contact.body.placeholder',"How can we help you?")}
                                        value={this.state.content}
                                        onChange={this.handleContentChange}
                                        disabled={this.state.disableActions}
                                    />
                                    <span
                                        className={
                                            typeof this.state.contentValid !== "undefined" &&
                                            !this.state.contentValid
                                                ? "contact-error contact-error--password active"
                                                : "login-error login-error--password"
                                        }
                                        id="spanContentChange"
                                    >
                                {this.props.t('contact.body.error',"This is a required field")}
                            </span>
                                </div>
                                <div className="cta__wrapp pv-xs">
                                    <input type="submit"
                                           className={submitDisabled ? "cta--normal cta--green cta--disabled" : "cta--normal cta--green"}
                                           value={this.props.t('contact.content.submit',"Send")}
                                           disabled={this.state.disableActions || submitDisabled} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <SidebarRightMobile/>
            </section>
        );
    }
}

export default withToastManager(withGlobalContext(withAuthenticationContext(withTranslation()(Contact))));
